import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * AdminRoute - Protects admin-only pages.
 * - Not logged in → redirect to /login
 * - Logged in but not admin → redirect to /home
 * - Admin → render children
 */
function AdminRoute({ children }) {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) return <p className="loading-text">Loading...</p>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (!isAdmin()) return <Navigate to="/home" replace />;
  return children;
}

export default AdminRoute;
